import { useEffect } from "react"
import { useQueryClient } from "@tanstack/react-query"
import useCentrifugeManagerService from "@/core/hooks/centrifuge/useCentrifugeManagerService"

export default function RealtimeExchangeProvider({ userId }: { userId?: string }) {
  const queryClient = useQueryClient()
  const { socketManager } = useCentrifugeManagerService()

  useEffect(() => {
    if (!socketManager || !userId) return

    // Subscribe to exchange updates channel specific to this user
    const channel = `exchange_updates#${userId}`
    
    console.log(`[RealtimeExchange] Subscribing to channel: ${channel}`)

    socketManager.subscribeChannel(channel, {
      subscribing: () => {
        console.log('[RealtimeExchange] Subscribing to exchange updates...')
      },
      subscribed: () => {
        console.log('[RealtimeExchange] Successfully subscribed to exchange updates')
      },
      publication: (data: any) => {
        console.log('[RealtimeExchange] Received update:', data)
        
        // Handle different types of exchange updates
        if (data.type === 'ORDER_FILLED' || data.type === 'ORDER_UPDATED') {
          console.log('[RealtimeExchange] Order update detected, refreshing exchange data...')
          
          // Invalidate all exchange-related queries for instant refresh
          queryClient.invalidateQueries({ queryKey: ['exchangeOverview'] })
          queryClient.invalidateQueries({ queryKey: ['exchangeAllocations'] })
          queryClient.invalidateQueries({ queryKey: ['spotTradingAllocations'] })
          queryClient.invalidateQueries({ queryKey: ['exchangeHistory'] })
          queryClient.invalidateQueries({ queryKey: ['exchangeReport'] })
        } else if (data.type === 'BALANCE_UPDATED') {
          console.log('[RealtimeExchange] Balance update detected, refreshing allocation data...')
          
          // Only refresh balance-related queries
          queryClient.invalidateQueries({ queryKey: ['exchangeAllocations'] })
          queryClient.invalidateQueries({ queryKey: ['spotTradingAllocations'] })
          queryClient.invalidateQueries({ queryKey: ['exchangeOverview'] })
        }
      }
    })

    return () => {
      console.log(`[RealtimeExchange] Unsubscribing from channel: ${channel}`)
      socketManager.unSubscribeChannel(channel)
    }
  }, [socketManager, userId, queryClient])

  return null
}
